import React from "react";
import PropTypes from "prop-types";
import { cn } from "../cn";
import styles from "./Card.module.scss";

/** Card — white surface, 1px border, no shadow unless `hoverable`. */
export function Card({ hoverable = false, className, children, ...rest }) {
  return (
    <div
      className={cn(styles.card, hoverable && styles.hoverable, className)}
      {...rest}
    >
      {children}
    </div>
  );
}

export function CardHeader({ className, children, ...rest }) {
  return (
    <div className={cn(styles.header, className)} {...rest}>
      {children}
    </div>
  );
}

export function CardTitle({ className, children, ...rest }) {
  return (
    <div className={cn(styles.title, className)} {...rest}>
      {children}
    </div>
  );
}

export function CardContent({ className, children, ...rest }) {
  return (
    <div className={cn(styles.content, className)} {...rest}>
      {children}
    </div>
  );
}

export function CardFooter({ className, children, ...rest }) {
  return (
    <div className={cn(styles.footer, className)} {...rest}>
      {children}
    </div>
  );
}

const childrenClassName = {
  className: PropTypes.string,
  children: PropTypes.node,
};
Card.propTypes = { hoverable: PropTypes.bool, ...childrenClassName };
CardHeader.propTypes = childrenClassName;
CardTitle.propTypes = childrenClassName;
CardContent.propTypes = childrenClassName;
CardFooter.propTypes = childrenClassName;

export default Card;
